import React from 'react';
import { Link } from 'react-router-dom';
import './Pricing.css';

const Pricing = () => {
  const plans = [
    {
      name: 'Starter',
      price: '29',
      features: [
        'Jusqu\'à 100 commandes/mois',
        'Confirmation WhatsApp & SMS',
        'Dashboard basique',
        'Support email'
      ]
    },
    {
      name: 'Pro',
      price: '79',
      features: [
        'Jusqu\'à 500 commandes/mois',
        'Confirmation WhatsApp & SMS',
        'Dashboard avancé',
        'Support prioritaire',
        'Statistiques avancées',
        'Export des données'
      ]
    },
    {
      name: 'Enterprise',
      price: '199',
      features: [
        'Commandes illimitées',
        'Tous les canaux de communication',
        'Dashboard personnalisé',
        'Support dédié 24/7',
        'API personnalisée',
        'Formation équipe'
      ]
    }
  ];

  return (
    <div className="pricing-container">
      <h1>Nos Offres</h1>
      <p className="pricing-subtitle">
        Choisissez le plan qui correspond à vos besoins
      </p>
      
      <div className="pricing-grid">
        {plans.map((plan, index) => (
          <div key={index} className="pricing-card">
            <h2>{plan.name}</h2>
            <div className="price">
              <span className="currency">€</span>
              <span className="amount">{plan.price}</span>
              <span className="period">/mois</span>
            </div>
            <ul className="features">
              {plan.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
            <Link to="/register" className="select-plan-btn">
              Commencer
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Pricing;
